import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot } from "vue"

import { ref, watch, onMounted } from "vue";
import { useDebounceFn } from "@vueuse/core";
import { useBreakpoints } from "@/code/useBreakpoints";
import { SearchApi } from "@/services/Api";
import { QuickSearchViewModel } from "@/models/QuickSearchViewModel";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressSearchWrapper',
  props: {
  scrolledTimeOut: {
    type: Boolean,
  },
  searchPageUrl: {
    type: String,
    required: true,
  },
  initialSearchQuery: {
    type: String,
    required: true,
  },
},
  emits: {
  close: () => true,
},
  setup(__props, { emit }) {

const props = __props;

const { isMd, isLg } = useBreakpoints();
const isPopupOpen = ref<boolean>();
const isSearchFieldOpen = ref<boolean>();





const openPopup = () => {
  scrolledTimeoutInternal.value = true;
  setTimeout(() => {
    scrolledTimeoutInternal.value = false;
  }, 1000);
  isPopupOpen.value = true;
  isSearchFieldOpen.value = true;
};

const closePopup = () => {
  isPopupOpen.value = false;
};

const closeSearchField = () => {
  isSearchFieldOpen.value = false;
};

const onFocus = () => {
  if (searchResults.value) {
    openPopup();
  }
};

const searchResults = ref<QuickSearchViewModel>();
const scrolledTimeoutInternal = ref<boolean>(false);
const searchModel = ref<string>(props.initialSearchQuery);

const search = async (query: string) => {
  if (query) {
    const res = await SearchApi.search(query, 6);
    searchResults.value = res;
    setTimeout(() => {
      openPopup();
    }, 100);
  } else {
    closePopup();
  }
};

const onSearchClick = async (query) => {
  await search(query);
};

const onCloseClick = () => {
  closePopup();
  closeSearchField();
  emit("close");
};

const onColdCloseClick = () => {
  searchModel.value = "";
  searchResults.value = undefined;
  closePopup();
  closeSearchField();
  emit("close");
};

onMounted(() => {
  window.addEventListener("scroll", () => {
    if (isLg.value) {
      if (!props.scrolledTimeOut && !scrolledTimeoutInternal.value) {
        onCloseClick();
      }
    }
  });
});

const onInput = (val: string) => {
  searchModel.value = val;
};

watch(isPopupOpen, (currVal) => {
  if (!isMd.value) {
    const bodyEl = document.querySelector("html") as HTMLHtmlElement;
    if (currVal) {
      bodyEl.style.overflow = "hidden";
    } else {
      bodyEl.style.overflow = "visible";
    }
  }
});

const rand = Math.random();
const onSearchClickDebounced = useDebounceFn(onSearchClick, rand * 200 + 300);

const onEnter = (term: string) => {
  if (searchResults.value && searchResults.value?.products && searchResults.value?.products.count === 1) {
    window.location.href = searchResults.value?.products.items[0].url;
  } else {
    window.location.href = `${props.searchPageUrl}?term=${term}`;
  }
};

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", {
    onEnter: onEnter,
    isPopupOpen: isPopupOpen.value,
    isSearchFieldOpen: isSearchFieldOpen.value,
    onSearchClick: _unref(onSearchClickDebounced),
    onCloseClick: onCloseClick,
    onColdCloseClick: onColdCloseClick,
    searchResults: searchResults.value,
    onFocus: onFocus,
    searchModel: searchModel.value,
    onInput: onInput
  })
}
}

})